import { AfterViewInit, Component, computed, ElementRef, inject, Injector, signal, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonButtonRowWidget, CommonForm, CommonTextField, CommonTextFieldWidget, UtilityService } from '@eforall/common';
import { DashboardDialogFramePart, DialogContext, DialogService } from '@eforall/dashboard';
import { ReadonlyAccessWidget } from '../../../../../../../ui/widget';
import { AcceleratorAreaService } from '../../../../accelerator-area.service';

@Component({
	selector: 'event-set-keynote-speaker-dialog',
	standalone: true,
	imports: [
		DashboardDialogFramePart,
		ReadonlyAccessWidget,
		CommonButtonRowWidget,
		CommonTextFieldWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './set-keynote-speaker.dialog.html',
})
export class EventSetKeynoteSpeakerDialog implements AfterViewInit {
	public dialog: DialogContext<{}> = inject(MAT_DIALOG_DATA);
	public dialogRef = inject(MatDialogRef<EventSetKeynoteSpeakerDialog>);
	public accAreaService = inject(AcceleratorAreaService);
	public util = inject(UtilityService);
	public dialogService = inject(DialogService);

	public speakerFormSaveBtn = viewChild.required<ElementRef<HTMLButtonElement>>('speakerFormSaveBtn');

	public acc = computed(() => this.accAreaService.data()?.acc);

	icon = signal('fa-regular fa-keynote');

	public isReadonly = computed(() => !this.accAreaService.canEdit());
	public readonly form = new CommonForm<{ bio: string | undefined, name: string | undefined }>(inject(Injector));


	readonly name = computed<CommonTextField>(() => ({
		config: signal({
			label: 'Name',
			isRequired: false,
			min: 0,
			max: 60,
			fixCase: 'title-case-forced',
			multiLine: false,
		}),
		formFieldName: 'name',
		form: this.form,
		actualValue: computed(() => this.acc()?.keynoteSpeakerName || ''),
		pendingValue: signal<string | null>(null),
		saving: signal(false),
		error: signal(''),
	}));


	readonly bio = computed<CommonTextField>(() => ({
		config: signal({
			label: 'Bio',
			min: 0,
			fixCase: 'sentence-case',
			isRequired: false,
			multiLine: true,
		}),
		formFieldName: 'bio',
		form: this.form,
		actualValue: computed(() => this.acc()?.keynoteSpeakerBio || ''),
		pendingValue: signal<string | null>(null),
		saving: signal(false),
		error: signal(''),
	}));




	ngAfterViewInit() {
		this.form.setSubmitButton(
			this.speakerFormSaveBtn(),
			async (values: { bio: string | undefined, name: string | undefined }, changed: string[]) => {
				console.log('Submitting event edit form with values:', values, 'and changed fields:', changed);
				const acc = this.acc();
				const name = values.name || undefined;
				const bio = values.bio || undefined;
				if (acc && (acc.keynoteSpeakerBio != bio || acc.keynoteSpeakerName != name)) {
					await this.accAreaService.setTrimesterKeynoteSpeaker(acc.accId, name, bio);
					this.close();
				}
			}
		);
	}

	public close() {
		this.dialogRef.close();
	}

}
